import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const Seo = ({ title, description, name, type, structuredData }) => {
    useEffect(() => {
        if (!structuredData) return;

        const scripts = [];
        const data = Array.isArray(structuredData) ? structuredData : [structuredData];

        data.forEach(item => {
            const script = document.createElement('script');
            script.type = 'application/ld+json';
            script.innerHTML = JSON.stringify(item);
            document.head.appendChild(script);
            scripts.push(script);
        });

        return () => {
            scripts.forEach(script => document.head.removeChild(script));
        };
    }, [structuredData]);

    return (
        <Helmet>
            { /* Standard metadata tags */}
            <title>{title}</title>
            <meta name='description' content={description} />
            <link rel="canonical" href={window.location.href} />
            { /* End standard metadata tags */}
            { /* Facebook tags */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={window.location.href} />
            <meta property="og:site_name" content="Project Graphil" />
            { /* End Facebook tags */}
            { /* Twitter tags */}
            <meta name="twitter:creator" content={name} />
            <meta name="twitter:card" content={type} />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            { /* End Twitter tags */}
        </Helmet>
    )
}

export default Seo;